import { render, staticRenderFns } from "./CloudBox.vue?vue&type=template&id=0ac362f6&scoped=true&"
import script from "./CloudBox.vue?vue&type=script&lang=js&"
export * from "./CloudBox.vue?vue&type=script&lang=js&"
import style0 from "./CloudBox.vue?vue&type=style&index=0&id=0ac362f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac362f6",
  null
  
)

export default component.exports